import { render, staticRenderFns } from "./AddLearningTask.vue?vue&type=template&id=42b883ee&scoped=true"
import script from "./AddLearningTask.vue?vue&type=script&lang=js"
export * from "./AddLearningTask.vue?vue&type=script&lang=js"
import style0 from "./AddLearningTask.vue?vue&type=style&index=0&id=42b883ee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b883ee",
  null
  
)

export default component.exports